import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.space',
    'resource:data.dimensions.space.attributes.sqft',
    'resource:data.dimensions.space.entities.room',
    'resource:data.dimensions.space.entities.room.attributes.roomType',
    'resource:data.dimensions.space.entities.room.attributes.hegisCode',
    'resource:data.dimensions.space.entities.floor',
    'resource:data.dimensions.space.entities.campus',
    'resource:data.dimensions.space.entities.building',
    'resource:data.dimensions.roomTypes',
    'resource:data.dimensions.roomTypes.entities.roomType',
    'resource:data.dimensions.roomTypes.entities.roomType.attributes.isLabService',
    'resource:data.dimensions.roomTypes.entities.roomType.attributes.isLab',
    'resource:data.dimensions.roomTypes.entities.roomType.attributes.hegisCode',
  ],
  description: 'TODO',
  name: 'Data - Space',
} as const satisfies core.quiver.Package
